/* eslint-disable no-case-declarations */
import Speech from 'speak-tts';
import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  speaker: new Speech(),
  initialized: false,
  enabled: false,
  alwaysPopup: true,
  modalVisible: false,
  speed: 1,
};

const SpeechReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.TOGGLE_SPEECH:
      let update = { enabled: !state.enabled };
      if (!state.initialized) {
        state.speaker.init({
          volume: 1,
          lang: 'en-US',
          rate: state.speed,
          pitch: 1,
          voice: 'Google US English',
          splitSentences: true,
        }).then((data) => {
          console.log('initialized');
        });
        update = { ...update, initialized: true };
      }
      return { ...state, ...update };
    case ActionTypes.SPEAK:
      const { text } = action.payload;
      if (state.enabled) {
        state.speaker.speak({ text, queue: false });
      }
      return state;
    case ActionTypes.TOGGLE_ALWAYS_POPUP:
      return { ...state, alwaysPopup: !state.alwaysPopup };
    case ActionTypes.TURN_OFF_SPEECH:
      return { ...state, enabled: false };
    case ActionTypes.UPDATE_SPEED:
      const { speed } = action.payload;
      state.speaker.setRate(speed);
      return { ...state, speed };
    default:
      return state;
  }
};

export default SpeechReducer;
